import script from "./activityInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./activityInfo.vue?vue&type=script&setup=true&lang=js"

import "./activityInfo.vue?vue&type=style&index=0&id=656e3baa&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656e3baa"]])

export default __exports__